import React, { useState } from "react";
import { MapPin, X, Maximize2 } from "lucide-react";
import Reveal from "./Reveal";
import { location } from "../mock";

const Location = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="location" className="bg-neg-green text-neg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div>
              <p className="text-neg-gold text-xs tracking-[0.3em] uppercase mb-5">
                Location
              </p>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.12]">
                {location.title.map((l, i) => (
                  <span key={i} className="block">
                    {l}
                  </span>
                ))}
              </h2>
              <p className="mt-6 text-neg-cream/70 leading-relaxed">{location.description}</p>

              <div className="mt-8 space-y-4">
                <h3 className="text-neg-gold text-sm tracking-widest uppercase">In the neighbourhood</h3>
                {location.neighbourhood.map((n) => (
                  <div key={n.label} className="flex gap-3">
                    <MapPin size={18} className="text-neg-gold shrink-0 mt-0.5" />
                    <p className="text-neg-cream/85">
                      <span className="font-semibold text-neg-cream">{n.label}: </span>
                      {n.value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <button
              onClick={() => setOpen(true)}
              className="group relative w-full overflow-hidden border border-neg-gold/30"
            >
              <img
                src={location.mapImage}
                alt="Location map"
                className="w-full h-[360px] lg:h-[520px] object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <span className="absolute inset-0 bg-neg-green/20 group-hover:bg-neg-green/0 transition-colors duration-500" />
              <span className="absolute bottom-4 right-4 inline-flex items-center gap-2 bg-neg-green/85 text-neg-gold px-4 py-2 text-xs tracking-widest uppercase backdrop-blur-sm">
                <Maximize2 size={14} /> Click to see location map
              </span>
            </button>
          </Reveal>
        </div>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 animate-fadein"
          onClick={() => setOpen(false)}
        >
          <button
            className="absolute top-5 right-5 text-neg-cream/80 hover:text-neg-gold transition-colors"
            onClick={() => setOpen(false)}
            aria-label="Close"
          >
            <X size={30} />
          </button>
          <img
            src={location.mapImage}
            alt="Location map enlarged"
            className="max-w-full max-h-[88vh] object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Location;
